import httpService from 'src/services/app/http.service'
import { log } from 'src/services/app/log.service'
import { idbService } from 'src/services/app/idb.service'
import { COMPANIES_ENDPOINTS, COMPANY_ENDPOINTS, STORAGE_KEYS } from 'src/services/consts/api.const'
import { refactorCompany, refactorCompanies } from 'src/services/helpers/companies.helper'

export const companiesService = {
  getCompanies,
  createCompany,
  deleteCompany,
  getCompanySuggestions,
}

async function getCompanies() {
  try {
    // Try to get companies from IndexedDB first
    const cachedCompanies = await idbService.getData(STORAGE_KEYS.COMPANIES)
    if (cachedCompanies) {
      log.info('Got companies from IndexedDB cache', { count: cachedCompanies.length })
      return cachedCompanies
    }

    // If not in cache or expired, fetch from API
    const res = await httpService.post(COMPANIES_ENDPOINTS.GET)
    if (!res?.companies) {
      return []
    }

    // Process and store the companies
    const companies = refactorCompanies(res.companies).sort((a, b) => a.name.localeCompare(b.name))
    await idbService.setData(STORAGE_KEYS.COMPANIES, companies)
    return companies
  } catch (err) {
    log.error('Failed to get companies:', err)
    return []
  }
}

async function getCompanySuggestions({ companyName }) {
  const suggestion = await httpService.post(COMPANY_ENDPOINTS.GET_SUGGESTIONS, {
    company_name: companyName,
  })

  // Handle the new API response structure
  if (suggestion.status === 'error') {
    return {
      error: suggestion.error || 'Failed to get suggestions',
    }
  }

  return {
    status: suggestion.status,
    aiSuggestion: suggestion.ai_suggestion,
    companiesInDb: suggestion.companies_in_db || [],
  }
}

async function createCompany({
  companyName,
  fullAiAssessment = false,
  startSubprocessorList = false,
}) {
  const payload = {
    company_name: companyName,
  }

  if (fullAiAssessment) {
    payload.start_company_full = true
  }

  if (startSubprocessorList) {
    payload.start_subprocessor_list = true
  }

  const response = await httpService.post(COMPANY_ENDPOINTS.CREATE, payload)
  // Transform the response using the refactoring function
  const companyData = refactorCompany({
    ...response,
    active: true,
    dpf_found: false,
    provides_ai_services: false,
    date_added: new Date().toISOString(),
  })
  return companyData
}

async function deleteCompany({ companyId }) {
  const response = await httpService.post(COMPANY_ENDPOINTS.DELETE, {
    company_id: companyId,
  })
  return response
}
